import moment from 'moment-timezone';
export const GET_WEBINARS_REQUEST = 'GET_WEBINARS_REQUEST';
export const GET_WEBINARS_FAILURE = 'GET_WEBINARS_FAILURE';
export const GET_WEBINARS_SUCCESS = 'GET_WEBINARS_SUCCESS';
export const TOGGLE_WEBINAR = 'TOGGLE_WEBINAR';
export const TOGGLE_ALL_WEBINARS = 'TOGGLE_ALL_WEBINARS';
export const FILTER_WEBINARS = 'FILTER_WEBINARS';

export function getWebinars(
  fromTime = moment()
    .subtract(2, 'year')
    .add(1, 'd')
    .startOf('day')
    .toISOString(),
  toTime = moment()
    .add(1, 'year')
    .endOf('day')
    .toISOString()
) {
  return {
    type: GET_WEBINARS_REQUEST,
    payload: { fromTime, toTime }
  };
}

export function toggleWebinar(webinarKey, isSelected) {
  return {
    type: TOGGLE_WEBINAR,
    payload: { webinarKey, isSelected }
  };
}

export function toggleAllWebinars(isSelected = true) {
  return {
    type: TOGGLE_ALL_WEBINARS,
    payload: { isSelected }
  };
}

export function filterWebinars(filterOptions) {
  const { searchString } = filterOptions;
  return {
    type: FILTER_WEBINARS,
    payload: { searchString }
  };
}



// WEBPACK FOOTER //
// ./src/Reducks/Webinars/WebinarsActions.js